import { Outlet } from "react-router-dom";

export default function FieldSetupMobileLayout() {
  return <Outlet />;
}
